import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, inject, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { NgClass } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';

import { IconComponent } from '@atoms/icon/icon.component';
import { SsrService } from '@services/ssr.service';

@Component({
  selector: 'app-slider',
  imports: [NgClass, TranslateModule, IconComponent],
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
})
export class SliderComponent implements AfterViewInit, OnChanges {
  private cd = inject(ChangeDetectorRef);
  private ssrService = inject(SsrService);
  @Input('item-width') itemWidth?: number;
  @Input() data?: any;
  @Input() gap: number = 8;
  @Input() padding: boolean = false;
  @ViewChild('sliderContent') sliderContent?: ElementRef;
  public minPosition: boolean = true;
  public maxPosition: boolean = false;
  private currentScroll: number = 0;
  public preventClick: boolean = false;

  @HostListener('window:resize', ['$event']) onResize(): void {
    this.move();
  }

  @HostListener('mouseup', ['$event']) onMouseUp(event: MouseEvent): void {
    if (this.preventClick) this.preventClick = false;
  }

  panStart(): void {
    if (this.ssrService.isServer()) return;
    if (window.innerWidth < 1000) return;
    this.preventClick = true;
    const sliderEl = this.sliderContent?.nativeElement;
    this.currentScroll = sliderEl.scrollLeft;
  }

  pan(event: any): void {
    if (this.ssrService.isServer()) return;
    if (window.innerWidth < 1000) return;
    const sliderEl = this.sliderContent?.nativeElement;
    const scroll = this.currentScroll - event.deltaX;
    sliderEl.scrollLeft = scroll;
  }

  panEnd(): void {
    if (this.ssrService.isServer()) return;
    if (window.innerWidth < 1000) return;
    this.preventClick = false;
  }

  move(direction?: 'prev' | 'next'): void {
    if (this.ssrService.isServer() || !this.sliderContent) return;
    const sliderScrollLeft = this.sliderContent.nativeElement.scrollLeft;
    const sliderScrollWidth = this.sliderContent.nativeElement.scrollWidth;
    const sliderClientWidth = this.sliderContent.nativeElement.clientWidth;
    let itemWidth = this.itemWidth || 0;
    if (itemWidth === 0) itemWidth = this.sliderContent.nativeElement.querySelector('app-slider-item')?.clientWidth || 0;
    let newScrollLeft = sliderScrollLeft;
    if (direction === 'prev') {
      newScrollLeft = sliderScrollLeft - itemWidth;
    } else if (direction === 'next') {
      newScrollLeft = sliderScrollLeft + itemWidth;
    }
    if (newScrollLeft <= 0) newScrollLeft = 0;
    else if (sliderScrollWidth - sliderClientWidth <= newScrollLeft) newScrollLeft = sliderScrollWidth - sliderClientWidth;
    this.minPosition = newScrollLeft <= 0;
    this.maxPosition = sliderScrollWidth - sliderClientWidth <= newScrollLeft;
    if (direction) {
      this.sliderContent.nativeElement.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth',
      });
    }
    this.cd.detectChanges();
  }

  ngAfterViewInit(): void {
    if (this.ssrService.isServer()) return;
    setTimeout(() => {
      this.move();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ssrService.isServer()) return;
    if (changes['data'] && changes['data'].currentValue && changes['data'].currentValue !== changes['data'].previousValue) {
      setTimeout(() => {
        this.move();
      });
    }
  }
}
